import { Button } from '~/shared/ui/Button/Button';
import { cvaTabs } from '~/widgets/FreeParking/Tabs/TabsStyles';
import { useStartDateStore } from '~/shared/store/startDateStore';

interface Tab {
  id: 'day' | 'week' | 'month';
  label: string;
}

const tabs: Tab[] = [
  { id: 'day', label: 'День' },
  { id: 'week', label: 'Неделя' },
  { id: 'month', label: 'Месяц' },
];

export const Tabs = () => {
  const { state, actions } = useStartDateStore();

  return (
    <div className={cvaTabs()}>
      {tabs.map((tab) => (
        <Button
          rubber
          size={'common'}
          key={tab.id}
          variant={state.activeTab === tab.id ? 'primary' : 'noneBg'}
          className={tab.id === 'week' ? 'tracking-tighter' : ''}
          onClick={() => actions.setTab(tab.id)}>
          {tab.label}
        </Button>
      ))}
    </div>
  );
};
